import api from "./axios";

// Fetch Requests (sent or received)
export const getRequestReceived = async (type = "received", page = 1) => {
    try {
        const response = await api.get(`/api/v1/customer/matches/chat/${type}?page=${page}`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to fetch requests");
        return [];
    }
};

// Like or Skip request
export const likeOrSkip = async (actionType, personId) => {
    try {
        const response = await api.post(`/api/v1/customer/matches/${actionType}`, { personId });
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to perform action");
        throw error;
    }
};

// Get Skipped Members List
export const getSkippedList = async () => {
    try {
        const response = await api.get(`/api/v1/customer/matches/skipped`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong");
        return [];
    }
};

// Get Blocked Members List
export const getBlockedList = async () => {
    try {
        const response = await api.get(`/api/v1/customer/matches/blocked`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong");
        return [];
    }
};

// Unblock a user
export const unblockUser = async (personId) => {
    try {
        const response = await api.post(`/api/v1/customer/matches/unblock`, {
            personId: personId,
        });
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong");
        throw error;
    }
};


// Get Reported Members List
export const getReportedList = async () => {
    try {
        const response = await api.get(`/api/v2/user/report`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong");
        return [];
    }
};

export const unReportUser = async (personId) => {
    try {
        const response = await api.delete(`/api/v2/user/report/${personId}`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong");
        throw error;
    }
};

export const getUnmatched = async () => {
    try {
        const response = await api.get(`/api/v2/user/unmatched`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong");
        return [];
    }
};

export const deleteUnmatched = async (unmatch_id) => {
    try {
        const response = await api.delete(`/api/v2/user/unmatched/${unmatch_id}`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong");
        throw error;
    }
};